import React from "react";
import {
  Typography,
  Dropdown,
  Checkbox,
  Badge,
  Button,
  Flex,
  Spin,
} from "antd";
import { CaretDownOutlined } from "@ant-design/icons";
import { useAspSelector } from "../../../../test/jest-redux-hooks";
import { useDispatch, useSelector } from "react-redux";
import { fetchWhatsappNumbers } from "../../../../reduxToolkit/channelSlice";

const { Text, Paragraph } = Typography;

const ChannelDropDown = ({
  dropDownLabel,
  dropDownList,
  onchange,
  onClear,
  dropdownHeader,
  listLoading,
}) => {
  const { currentBrand } = useSelector((state) => state.app);
  const { wapNumbersListBrandId } = useSelector((state) => state.Channel);

  const dispatch = useDispatch();

  const selectedCount = dropDownList.filter((item) => item.checked).length;

  const dropdownContent = (
    <div className="bg-white p-4 shadow-md rounded w-48">
      {listLoading ? (
        <Flex vertical className="space-y-4">
          <Spin size="small" />
        </Flex>
      ) : (
        <>
          <div className="flex justify-between items-center mb-2">
            <Text className="text-xs text-[#898E99]">
              {dropdownHeader || dropDownLabel}
            </Text>
            <Button type="link" className="p-0" onClick={onClear}>
              <Text className="text-red-500 text-xs">Clear</Text>
            </Button>
          </div>
          <Flex vertical className="space-y-4">
            {dropDownList.map((item) => (
              <Checkbox
                key={item.id}
                checked={item.checked}
                onChange={() => onchange(item.id)}
              >
                <Text className="text-xs">{item.name}</Text>
              </Checkbox>
            ))}
          </Flex>
        </>
      )}
    </div>
  );

  const loadPhoneNumberList = () => {
    if (dropDownList.length === 0 && dropDownLabel === "Phone number")
      dispatch(fetchWhatsappNumbers(currentBrand?.brand_id));
    else if (
      dropDownList.length !== 0 &&
      dropDownLabel === "Phone number" &&
      wapNumbersListBrandId !== currentBrand?.brand_id
    )
      dispatch(fetchWhatsappNumbers(currentBrand?.brand_id));
  };

  return (
    <Dropdown
      dropdownRender={() => dropdownContent}
      trigger={["click"]}
      className="bg-[#F4F6F8]"
      onOpenChange={(open) => {
        if (open) {
          loadPhoneNumberList();
        }
      }}
    >
      <button className="bg-gray-100 px-3 py-[.27rem] rounded-md flex justify-between items-center min-w-[130px] no-screenshot">
        <Flex justify="space-between" align="center">
          <Paragraph style={{ margin: 0 }} className="text-xs">
            {dropDownLabel}
          </Paragraph>
          <Badge
            // size="small"
            color={selectedCount ? "transparent" : "default"}
            dot={false}
            styles={{
              indicator: {
                backgroundColor: "transparent",
                color: "black",
                border: 0,
                borderColor: "transparent",
              },
            }}
            count={
              selectedCount == dropDownList.length && dropDownList.length != 0
                ? "(All)"
                : selectedCount
            }
          />
        </Flex>
        <CaretDownOutlined className="text-gray-500 size-3" />
      </button>
    </Dropdown>
  );
};

export default ChannelDropDown;
